/**
 * Vendor Location Form Modal
 *
 * Thin wrapper around the shared LocationFormModal with vendor-specific defaults.
 * - Uses vendor translation namespace
 * - Uses isDefaultReceiving field
 */

import SharedLocationFormModal, {
  VendorLocationFormData,
  LocationFormData as SharedLocationFormData,
} from '@/components/shared/LocationFormModal';

// Re-export the vendor-specific form data type for backward compatibility
export type LocationFormData = VendorLocationFormData;
export type { VendorLocationFormData };

interface LocationFormModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: (location: LocationFormData) => void;
  location?: LocationFormData | null;
  /** When true, displays form in read-only mode (view mode) */
  readOnly?: boolean;
  /** When true, shows a loading spinner instead of form content */
  loading?: boolean;
}

const LocationFormModal = ({
  visible,
  onClose,
  onSuccess,
  location,
  readOnly = false,
  loading = false,
}: LocationFormModalProps) => {
  // Wrap onSuccess to cast from union type to vendor-specific type
  const handleSuccess = (data: SharedLocationFormData) => {
    onSuccess(data as VendorLocationFormData);
  };

  return (
    <SharedLocationFormModal
      visible={visible}
      onClose={onClose}
      onSuccess={handleSuccess}
      location={location}
      readOnly={readOnly}
      loading={loading}
      entityType="vendor"
    />
  );
};

export default LocationFormModal;
